import React, { useState } from 'react'
import Page from 'src/components/Page'
import { Grid, Button, Typography, TextField, Snackbar, Autocomplete, Fade, Box, InputAdornment } from '@mui/material';
import Alert from 'src/components/Alert';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ArcelikLogo from 'src/assets/images/arcelik_marka_logo.png';
import AsrBolgeHizmetAdetleri from 'src/assets/AsrExcel/ASR_BOLGE_HIZMET_ADETLERI.xlsx'
import AsrBolgeServisAdetleri from 'src/assets/AsrExcel/ASR_BOLGE_SERVIS_ADETLERI.xlsx'
import AsrMontajSatisBolgeleri from 'src/assets/AsrExcel/ASR_MONTAJ_SATIS_BOLGELERI.xlsx'
import AsrMontajUrunBazli from 'src/assets/AsrExcel/ASR_MONTAJ_URUN_BAZLI.xlsx'
import AsrUdsDegisimNedenleri from 'src/assets/AsrExcel/ASR_UDS_DEGISIM_NEDENLERI.xlsx'
import AsrUdsDegisimTuru from 'src/assets/AsrExcel/ASR_UDS_DEGISIM_TURU.xlsx'
import AsrUrunHizmetAdet from 'src/assets/AsrExcel/ASR_URUN_HIZMET_ADET.xlsx'
import HandymanIcon from '@mui/icons-material/Handyman';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import InventoryIcon from '@mui/icons-material/Inventory';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import axios from 'axios';

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    }),
    header: {
        fontFamily: 'AssistantRegular',
        paddingTop: '1rem',
        paddingBottom: '1rem'
    },
    container: {
        overflow: 'auto',
        maxHeight: '90vh'
    },
    downloadButton: {
        width: '20rem',
        marginTop: '1rem'
    }
};

const files = [
    {
        path: AsrBolgeHizmetAdetleri,
        fileName: 'ASR_BOLGE_HIZMET_ADETLERI.xlsx',
        displayName: 'Bölge Hizmet Adetleri',
        groupType: 'Bölge'
    },
    {
        path: AsrBolgeServisAdetleri,
        fileName: 'ASR_BOLGE_SERVIS_ADETLERI.xlsx',
        displayName: 'Bölge Servis Adetleri',
        groupType: 'Bölge'
    },
    {
        path: AsrMontajSatisBolgeleri,
        fileName: 'ASR_MONTAJ_SATIS_BOLGELERI.xlsx',
        displayName: 'Montaj Satış Bölgeleri',
        groupType: 'Montaj'
    },
    {
        path: AsrMontajUrunBazli,
        fileName: 'ASR_MONTAJ_URUN_BAZLI.xlsx',
        displayName: 'Montaj Ürün Bazlı',
        groupType: 'Montaj'
    },
    {
        path: AsrUdsDegisimNedenleri,
        fileName: 'ASR_UDS_DEGISIM_NEDENLERI.xlsx',
        displayName: 'ÜDS Değişim Nedenleri',
        groupType: 'ÜDS'
    },
    {
        path: AsrUdsDegisimTuru,
        fileName: 'ASR_UDS_DEGISIM_TURU.xlsx',
        displayName: 'ÜDS Değişim Türü',
        groupType: 'ÜDS'
    },
    {
        path: AsrUrunHizmetAdet,
        fileName: 'ASR_URUN_HIZMET_ADET.xlsx',
        displayName: 'Ürün Hizmet Adet',
        groupType: 'Ürün'
    }
];

const getGroupIcon = (groupType) => {
    if (groupType === 'Bölge') {
        return <HomeRepairServiceIcon fontSize="small" />;
    } else if (groupType === 'Montaj') {
        return <HandymanIcon fontSize="small" />;
    } else if (groupType === 'ÜDS') {
        return <CurrencyExchangeIcon fontSize="small" />;
    } else {
        return <InventoryIcon fontSize="small" />;
    }
};

function AsrReports() {
    const [selectedFile, setSelectedFile] = useState("");
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [responseMessage, setResponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const handleDownload = async () => {
        if (selectedFile) {
            const filePath = selectedFile.path;
            try {
                const response = await axios.head(filePath);

                if (response.status === 200) {
                    // Dosya mevcut ve indirilebilir
                    const link = document.createElement('a');
                    link.href = filePath;
                    link.setAttribute('download', selectedFile.displayName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    setResponseMessage('İndirme işlemi tamamlandı!');
                    setUyariTip('success');
                    setUyari(true);
                } else {
                    // Dosya mevcut değil veya indirilemez
                    setResponseMessage('Dosya indirilemedi. Lütfen tekrar deneyin.');
                    setUyariTip('error');
                    setUyari(true);
                }
            } catch (error) {
                // Ağ hatası veya başka bir hata
                setResponseMessage('İndirme sırasında bir hata oluştu.');
                setUyariTip('error');
                setUyari(true);
            }
        }
    };

    return (
        <>
            <Snackbar
                open={uyari}
                autoHideDuration={2000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                />
            </Snackbar>
            <Page sx={styles.root}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" style={styles.container}>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 12
                        }}>
                        <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Fade timeout={1000} in={true}>
                                <img
                                    src={ArcelikLogo}
                                    alt="Arçelik"
                                    style={{ width: '100%', maxWidth: 200 }}
                                />
                            </Fade>
                        </Grid>
                        <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Fade in={true} timeout={1000}>
                                <Typography
                                    style={styles.header}
                                    variant="h2"
                                    gutterBottom
                                >
                                    Arçelik Servis Raporları
                                </Typography>
                            </Fade>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 12
                        }}>
                        <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Fade in={true} timeout={1000}>
                                <Autocomplete
                                    value={selectedFile || null}
                                    size="small"
                                    sx={{ width: '22rem', maxWidth: '90vw' }}
                                    onChange={(event, newValue) => {
                                        setSelectedFile(newValue);
                                    }}
                                    options={files}
                                    groupBy={(option) => option.groupType}
                                    getOptionLabel={(option) => option.displayName}
                                    isOptionEqualToValue={(option, value) => option.fileName === value.fileName}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Excel Dosya Türü"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <InputAdornment position="start" sx={{ color: 'primary.main', ml: 0.25 }}>
                                                        <DescriptionOutlinedIcon fontSize="small" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <Box component="li" {...props} key={option.fileName} sx={{ py: '6px !important', px: 2 }}>
                                            <Typography variant="body2" noWrap>{option.displayName}</Typography>
                                        </Box>
                                    )}
                                    renderGroup={(params) => (
                                        <li key={params.key}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    position: 'sticky',
                                                    top: -8,
                                                    zIndex: 1,
                                                    px: 2,
                                                    py: 0.75,
                                                    bgcolor: 'background.paper',
                                                    borderBottom: '1px solid',
                                                    borderColor: 'divider'
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'grid',
                                                        placeItems: 'center',
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: '50%',
                                                        color: 'primary.main',
                                                        bgcolor: 'rgba(255, 152, 0, 0.12)'
                                                    }}
                                                >
                                                    {getGroupIcon(params.group)}
                                                </Box>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                                    {params.group}
                                                </Typography>
                                            </Box>
                                            <ul style={{ padding: 0 }}>
                                                {params.children}
                                            </ul>
                                        </li>
                                    )}
                                    slotProps={{
                                        paper: {
                                            elevation: 8,
                                            sx: { mt: 0.75, borderRadius: 2, border: '1px solid', borderColor: 'divider' }
                                        }
                                    }}
                                />
                            </Fade>
                        </Grid>
                        <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Fade in={true} timeout={1000}>
                                <Typography
                                    variant="subtitle2"
                                    style={{ fontFamily: "Segoe UI" }}
                                >
                                    Lütfen indirmek istediğiniz Exceli seçiniz...
                                </Typography>
                            </Fade>
                        </Grid>
                        <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Fade in={true} timeout={1000}>
                                <Button
                                    style={styles.downloadButton}
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => { handleDownload(); }}
                                    endIcon={<FileDownloadIcon />}
                                    disabled={!selectedFile}
                                >
                                    İNDİR
                                </Button>
                            </Fade>
                        </Grid>
                    </Grid>
                </Grid>
            </Page>
        </>
    );
}

export default AsrReports;